<template>
  <div class="platform-selector">
    <div class="platform-buttons">
      <button
        v-for="(platform, index) in platforms"
        :key="index"
        :class="{ selected: selectedPlatform === platform.value }"
        @click="handleChange(platform.value)"
      >
        {{ platform.text }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedPlatform: 'ios', // 默认选中的平台
      platforms: [
        { value: 'ios', text: 'iOS' },
        { value: 'android', text: 'Android' },
        { value: 'frontend', text: '前端' },
        { value: 'miniapp', text: '小程序' }
      ]
    };
  },
  methods: {
    handleChange(platform) {
      this.selectedPlatform = platform;
      this.$emit('platform-change', this.selectedPlatform);
    }
  }
};
</script>

<style scoped>
.platform-selector {
  margin-bottom: 20px;
  justify-content: center; /* 水平居中 */
  align-items: center;
}

.platform-buttons {
  display: flex;
  margin-left: 10%;
  width: 80%;
  margin-top: 10px;
}

.platform-buttons button {
  flex: 1;
  padding: 10px;
  border: none;
  background-color: transparent;
  text-align: center;
  cursor: pointer;
  outline: none;
  transition: background-color 0.3s;
  position: relative;
  margin: 0 5px; /* 添加间距 */
  color: white;
  font-size: 22px;
}

.platform-buttons button.selected {
    background-color: rgb(233, 245, 249, 0.1);
  color: white;
}

.platform-buttons button.selected::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 4px; /* 矩形方块的高度 */
  background-color: #007bff; /* 矩形方块的颜色 */
}
</style>